import classnames from 'classnames';

import Icon, { icons } from '../Icon';

import ButtonBase from './Base';
import { BUTTON_SIZE, BUTTON_TYPE } from './button-constants';
import type { GetButtonProps } from './Base';
import type { ButtonProps } from './Button';

export type LoaderButtonProps = ButtonProps & {
  /**
   * If the loader should be displayed or not
   */
  isLoading?: boolean;
};

/**
 * Button that accepts an `isLoading` prop which, if true,
 * renders a loader icon instead of the contents. Otherwise
 * just render the contents/children.
 */
const LoaderButton = ({
  type = BUTTON_TYPE.PRIMARY,
  size = BUTTON_SIZE.SMALL,
  icon,
  isDisabled,
  isFullWidth,
  isSubmitButton,
  children,
  onClick,
  testId,
  isLoading,
}: LoaderButtonProps) => (
  <ButtonBase
    type={type}
    size={size}
    isDisabled={isDisabled}
    isFullWidth={isFullWidth}
    isSubmitButton={isSubmitButton}
    onClick={onClick}
    testId={testId}
  >
    {(getButtonProps: GetButtonProps) => (
      // Note: disabling, because `getButtonProps` returns a button type.
      // eslint-disable-next-line react/button-has-type
      <button
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...getButtonProps()}
      >
        <span className="fossa-button__contents">
          {isLoading
            ? (
              <Icon
                icon={icons.circleO}
                hasSpin
              />
              )
            : (
              <>
                {icon && (
                  <span className={classnames('fossa-button__icon', {
                    'fossa-button__icon--solo': !children, // Remove margin if only child
                  })}>
                    <Icon icon={icon} />
                  </span>
                )}
                <span className="fossa-button__text">
                  {children}
                </span>
              </>
              )}
        </span>
      </button>
    )}
  </ButtonBase>
);

export default LoaderButton;
